// extracted by mini-css-extract-plugin
module.exports = {"feed":"Feed_feed__161vt","top":"Feed_top__1PTxo"};